import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";

import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import ModalPreview from "components/Common/ModalPreview";
import {
  COLOR_DURATION_WORK,
  COLOR_EMPLOYMENT_TYPE,
  COLOR_SOURCE_CHANNEL,
  COLOR_SOURCE_CREATOR,
  COLOR_STATUS_ACTIVE_DISABLE,
  COLOR_STATUS_JOB_POST,
  ENUM_STATUS_JOB_POST,
  LIST_OPTION_DURATION_WORK,
  LIST_OPTION_EMPLOYMENT_TYPE,
  LIST_OPTION_GENDER,
  LIST_OPTION_SALARY_TYPE,
  LIST_OPTION_SOURCE_CHANNEL,
  LIST_OPTION_SOURCE_CREATOR,
  LIST_OPTION_STATUS_JOB_POST,
  PLAN_FEATURE_KEY_OPTION,
  sortDays,
  STATUS_ACTIVE_DISABLE_OPTION,
  STATUS_JOB_POST_DISPLAY_STATUS_OPTION,
} from "helpers/constans";
import { formatDateStringToKorea, formatDateStringToUTC, formatNumber, formatNumberWithCommas } from "helpers/format";
import CountUp from "react-countup";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import noImageJob from "../../assets/images/no-job-post.png";
import CopyWrapper from "components/Common/CopyWrapper";
import { getJobPosts } from "store/job-post/thunk";
import JobForm from "./JobForm";
import jobPostApi, { benifitJobPostApi } from "api/jobPostApi";
import { IBenifit } from "api/types/_jobpost";
import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";
import regionApi from "api/regionApi";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import NO_IMAGE_JOB from "../../assets/images/no-job-post.png";
import { TreeSelect } from "antd";
import sectionApi from "api/sectionApi";
import plansApi from "api/planApi";
import DropdownAsyncPlan from "components/Common/DropdownAsyncPlan";
import jobCategoryApi from "api/jobCategoryApi";

registerLocale("en", en);
registerLocale("ko", ko);

const JobPostManagement = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    jobTitle: withDefault(StringParam, ""),
    email: withDefault(StringParam, ""),
    storeName: withDefault(StringParam, ""),
    businessNumber: withDefault(StringParam, ""),
    storeAddress: withDefault(StringParam, ""),
    salaryTypes: withDefault(StringParam, ""),
    employmentTypes: withDefault(StringParam, ""),
    durationWork: withDefault(StringParam, ""),
    gender: withDefault(StringParam, ""),
    regionIds: withDefault(StringParam, ""),
    subRegionIds: withDefault(StringParam, ""),
    jobStatus: withDefault(StringParam, ""),
    sourceCreator: withDefault(StringParam, ""),
    sourceChannel: withDefault(StringParam, ""),
    displayStatus: withDefault(StringParam, ""),
    startDate: withDefault(StringParam, ""),
    endDate: withDefault(StringParam, ""),
    planId: withDefault(StringParam, ""),
    sectionId: withDefault(StringParam, ""),
  });

  const [jobTitleSearch, setJobTitleSearch] = useState<string>(query?.jobTitle || "");
  const [emailSearch, setEmailSearch] = useState<string>(query?.email || "");
  const [storeNameSearch, setStoreNameSearch] = useState<string>(query?.storeName || "");
  const [businessNumberSearch, setBusinessNumberSearch] = useState<string>(query?.businessNumber || "");
  const [storeAddressSearch, setStoreAddressSearch] = useState<string>(query?.storeAddress || "");
  const [isShowBannerPremium, setIsShowBannerPremium] = useState<boolean>(false);

  const [salaryTypeSearch, setSalaryTypeSearch] = useState<any>(
    LIST_OPTION_SALARY_TYPE?.find(
      (item) => item?.value === (query?.salaryTypes)
    )?.value ?? ""
  );

  const [employmentTypeSearch, setEmploymentTypeSearch] = useState<any>(
    LIST_OPTION_EMPLOYMENT_TYPE?.find(
      (item) => item?.value === (query?.employmentTypes)
    )?.value ?? ""
  );

  const [sourceCreatorSearch, setSourceCreatorSearch] = useState<any>(
    LIST_OPTION_SOURCE_CREATOR?.find(
      (item) => item?.value === (query?.sourceCreator)
    )?.value ?? ""
  );

  const [sourceChannelSearch, setSourceChannelSearch] = useState<any>(
    LIST_OPTION_SOURCE_CHANNEL?.find(
      (item) => item?.value === (query?.sourceChannel)
    )?.value ?? ""
  );

  const [displayStatusSearch, setDisplayStatusSearch] = useState<any>(
    STATUS_ACTIVE_DISABLE_OPTION?.find(
      (item) => item?.value === (query?.displayStatus)
    )?.value ?? ""
  );

  const [durationWorkSearch, setDurationWorkSearch] = useState<any>(
    LIST_OPTION_DURATION_WORK?.find(
      (item) => item?.value === (query?.durationWork)
    )?.value ?? ""
  );

  const [genderSearch, setGenderSearch] = useState<any>(
    LIST_OPTION_GENDER?.find(
      (item) => item?.value === (query?.gender)
    )?.value ?? ""
  );

  const [planSearch, setPlanSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  })

  const [sectionSearch, setSectionSearch] = useState<string>(query?.sectionId || "");
  
  const [lstTreeRegion, setLstTreeRegion] = useState<any>([]);
  const [selectedRegionSearch, setSelectedRegionSearch] = useState<any>(["ALL"]);

  const [jobStatusSearch, setJobStatusSearch] = useState<any>(
    LIST_OPTION_STATUS_JOB_POST?.find(
      (item) => item?.value === (query?.jobStatus)
    )?.value ?? ""
  );

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.startDate
      ? moment(query?.startDate || "", "Y-MM-DD").toDate()
      : null,
    query?.endDate ? moment(query?.endDate || "", "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToEdit, setItemToEdit] = useState<any>(null);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [dataBenifits, setDataBenifits] = useState<IBenifit[]>([]);
  const [dataConditions, setDataConditions] = useState<any>([]);
  const [regions, setRegions] = useState<any>(null);
  const [dataSection, setDataSection] = useState<any>([]);
  const [dataPlan, setDataPlan] = useState<any>([]);
  const [dataPlanAll, setDataPlanAll] = useState<any>([]);
  const [dataJobCategory, setDataJobCategory] = useState<any>([]);

  const selectLayoutState = (state: any) => state.JobPost;
  const CompanyProperties = createSelector(selectLayoutState, (state) => ({
    jobPosts: state?.jobPosts,
    isJobPostLoading: state.isJobPostLoading,
    isJobPostSuccess: state.isJobPostSuccess,

    error: state.error,
  }));

  // Inside your component
  const { jobPosts, isJobPostLoading } = useSelector(CompanyProperties);

  useEffect(() => {
    dispatch(getJobPosts(query));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  const parseRegionsToString = (inputList: string[]) => {
    const regionSet = new Set<number>();
    const subRegionSet = new Set<number>();

    inputList.forEach((item) => {
      if (item.includes("-")) {
        const [region, subRegion] = item.split("-").map(Number);
        regionSet.add(region);       
        subRegionSet.add(subRegion);
      } else {
        regionSet.add(Number(item));
      }
    });

    const lstRegion = Array.from(regionSet).sort((a, b) => a - b).join(",");
    const lstSubRegion = Array.from(subRegionSet).sort((a, b) => a - b).join(",");

    return { lstRegion, lstSubRegion };
  };

  const searchData = () => {
    let lstRegionId = "";
    let lstSubRegionId = "";
    if(selectedRegionSearch?.length > 0 && !selectedRegionSearch.includes("ALL")) {
      const { lstRegion, lstSubRegion } = parseRegionsToString(selectedRegionSearch);
      lstRegionId = lstRegion;
      lstSubRegionId = lstSubRegion;
    }

    setQuery({
      ...query,
      jobTitle: encodeURIComponent(jobTitleSearch.trim()) || "",
      email: emailSearch.trim(),
      storeName: storeNameSearch.trim(),
      businessNumber: businessNumberSearch.trim(),
      storeAddress: encodeURIComponent(storeAddressSearch.trim()) || "",
      salaryTypes: salaryTypeSearch,
      employmentTypes: employmentTypeSearch,
      durationWork: durationWorkSearch,
      gender: genderSearch,
      regionIds: lstRegionId || "",
      subRegionIds: lstSubRegionId || "",
      jobStatus: jobStatusSearch,
      sourceChannel: sourceChannelSearch,
      sourceCreator: sourceCreatorSearch,
      displayStatus: (displayStatusSearch === 0) ? false : ((displayStatusSearch === 1) ? true : ""),
      planId: (planSearch?.value !== 'all' && planSearch) ? planSearch?.value : "",
      sectionId: sectionSearch || "",
      startDate: startDate
        ? formatDateStringToUTC(
          moment(new Date(startDate))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      endDate: endDate
        ? formatDateStringToUTC(
          moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      //sortBy: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        jobTitle: "",
        email: "",
        storeName: "",
        businessNumber: "",
        storeAddress: "",
        salaryTypes: "",
        employmentTypes: "",
        durationWork: "",
        gender: "",
        regionIds: "",
        subRegionIds: "",
        jobStatus: "",
        sourceChannel: "",
        sourceCreator: "",
        displayStatus: "",
        planId: "",
        sectionId: "",
        startDate: "",
        endDate: "",
        sortBy: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setJobTitleSearch("");
    setEmailSearch("");
    setStoreNameSearch("");
    setBusinessNumberSearch("");
    setStoreAddressSearch("");
    setSalaryTypeSearch("");
    setEmploymentTypeSearch("");
    setDurationWorkSearch("");
    setGenderSearch("");
    setSelectedRegionSearch(["ALL"]);
    setJobStatusSearch("");
    setSourceChannelSearch("");
    setSourceCreatorSearch("");
    setDisplayStatusSearch("");
    setPlanSearch("");
    setSectionSearch("");
    setDateSearch([null, null]);
  };

  // Begin::Update User
  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    dispatch(getJobPosts(query));
  };
  //End::Update User

  const handleOnConfirmUpdate = async (item: {
      data: any;
      status: string | boolean;
    }) => {
      if (!item || !item?.data?.id) return;
  
      try {
        const formatData = {
          displayStatus: item?.status
        }
        const response: any = await jobPostApi.updateDisplayStatusJobPost(item?.data?.id, formatData);
        if (response?.code === 200) {
          dispatch(getJobPosts(query));
          toast(
            `${t("The process has been completed.")}`,
            CONFIG_OPTION_TOAST_NORMAL
          );
        } else {
          toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
        }
      } catch (error: any) {
        toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
        return error;
      }
    };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: 35 }}>
              {jobPosts?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Display Status"),
        accessor: "displayStatus",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "text-center",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
              style={{ minWidth: "80px" }}
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="status"
                checked={cell?.value}
                onChange={(e) => {
                  const value = e?.target?.checked;
                  handleOnConfirmUpdate({
                    data: item,
                    status: value === true ? true : false,
                  });
                }}
              />
            </div>
          );
        },
      },
      {
        Header: t("Job Status"),
        accessor: "status",
        thWidth: 120,
        thClass: "text-center  whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          let status: any = item?.status;
          if (item?.status == ENUM_STATUS_JOB_POST.ACTIVE && item?.displayStartDate) {
            const currentDate = moment(moment().tz("Asia/Seoul").format('YYYY-MM-DD HH:mm:ss'));
            const applicationStartDate = formatDateStringToKorea(item?.displayStartDate);

            if (currentDate.isBefore(moment(applicationStartDate))) {
              status = ENUM_STATUS_JOB_POST.SCHEDULE
            }
          }

          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_STATUS_JOB_POST[status] || "secondary"
                  }`}
              >
                {t(
                  LIST_OPTION_STATUS_JOB_POST?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Job Thumbnail"),
        accessor: "jobAttachment",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 120,
        Cell: (cell: any) => {
          const itemImages = cell?.value;
          const jobImage = itemImages?.[0]?.url || "";
          // const formatPreviewImages = itemImages?.length > 0 && itemImages?.map((image: any) => (image?.url));

          return <>
            <div className="w-100 text-center " style={{ minWidth: "80px" }}>
              <div
                style={{ width: "80px" }}
                className="m-auto cursor-pointer"
                onClick={() => setLinkImage(itemImages?.length > 1 ? { urls: itemImages } : { url: jobImage })}
              // onClick={() => setLinkImage(jobImage ?? noImageJob)}
              >
                <img
                  src={jobImage ?? noImageJob}
                  width={70}
                  height={70}
                  className=""
                  style={{ objectFit: "contain" }}
                  alt="thumbnail"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = noImageJob;
                  }}
                />
              </div>
            </div>
          </>
        },
      },
      {
        Header: t("Job Title"),
        accessor: "title",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 280,
        Cell: (cell: any) => {
          const contactName = cell?.value;
          const item = cell?.row?.original;

          return contactName ? <div 
              className="cursor-pointer text-primary"
              onClick={() => {
                setIsOpen(true);
                setItemToEdit(item);
              }}
              >
            <CopyWrapper contentCopy={contactName}>
              {`${contactName}`}
            </CopyWrapper>
          </div> : '-';
        },
      },
      {
        Header: t("Owner Post"),
        accessor: "Store",
        filterable: false,
        sortable: false,
        thWidth: 340,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const owner = cell?.row?.original?.owner;
          return owner ? (
            <div
              className="d-flex align-items-center gap-2"
            >
              <div
                className="cursor-pointer overflow-hidden object-fit-cover"
                style={{
                  height: "65px",
                  width: "65px",
                  minWidth: "65px",
                }}
                onClick={() =>
                  setLinkImage({ url: owner?.storeThumbnail || "" })
                }
              >
                <img
                  className="overflow-hidden object-fit-cover"
                  src={owner?.storeThumbnail || NO_IMAGE_JOB}
                  alt={owner?.storeName}
                  height={65}
                  width={65}
                  style={{
                    minWidth: "65px",
                  }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = NO_IMAGE_JOB;
                  }}
                />
              </div>

              <div className="d-flex flex-column" style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                <div className="fw-semibold">
                  <CopyWrapper contentCopy={owner?.email || ""}>
                    {owner?.email || ""}
                  </CopyWrapper>
                </div>
                <div>
                  <CopyWrapper contentCopy={owner?.storeName || ""}>
                    {owner?.storeName || ""}
                  </CopyWrapper>
                </div>
                <small className="text-secondary">
                  <CopyWrapper contentCopy={owner?.businessNumber || ""}>
                    {owner?.businessNumber || ""}
                  </CopyWrapper>
                </small>
                <small className="text-secondary">
                  <CopyWrapper contentCopy={owner?.storeShortAddress || ""}>
                    {owner?.storeShortAddress || ""}
                  </CopyWrapper>
                </small>
              </div>
            </div>
          ) : "-";
        },
      },
      {
        Header: t("Source Creator"),
        accessor: "sourceCreator",
        thWidth: 140,
        thClass: "text-center  whitespace-nowrap",
        Cell: (cell: any) => {
          const sourceCreator = cell?.value;

          return sourceCreator ? (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_SOURCE_CREATOR[sourceCreator] || "secondary"
                  }`}
              >
                {t(
                  LIST_OPTION_SOURCE_CREATOR?.find(
                    (item: any) => String(item?.value) === String(sourceCreator)
                  )?.label || ""
                )}
              </span>
            </div>
          ) : <div className="text-center">-</div>;
        },
      },
      {
        Header: t("Source Channel"),
        accessor: "sourceChannel",
        thWidth: 140,
        thClass: "text-center  whitespace-nowrap",
        Cell: (cell: any) => {
          const sourceChannel = cell?.value;

          return sourceChannel ? (
            <div className="text-center" style={{ minWidth: 80 }}>
              <div
                className={`align-items-center gap-1 bg-primary badge rounded-pill bg-${COLOR_SOURCE_CHANNEL[sourceChannel] || "secondary"}`}
              >
                {t(
                  LIST_OPTION_SOURCE_CHANNEL?.find(
                    (item: any) => String(item?.value) === String(sourceChannel)
                  )?.label || ""
                )}
              </div>
            </div>
          ) : <div className="text-center">-</div>;
        },
      },
      {
        Header: t("Number of recruits"),
        accessor: "headCount",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap text-end",
        thWidth: i18n?.language === 'en' ? 160 : 120,
        Cell: (cell: any) => {
          let numberOfRecruits = cell?.value;
          if (cell?.value) {
            numberOfRecruits = formatNumberWithCommas(cell?.value);
          } else {
            numberOfRecruits = t("Ongoing Recruitment");
          }
          return <div className="cursor-pointer text-end">{`${numberOfRecruits}`}</div>;
        },
      },
      {
        Header: t("Application Start"),
        accessor: "displayStartDate",
        filterable: true,
        sortable: false,
        thWidth: 140,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = cell?.value ? moment.utc(cell?.value).format("YYYY-MM-DD") : "";

          return date ? (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>{date || ""}</span> <br />{" "}
            </div>
          ) : <div className="text-end">-</div>;
        },
      },
      {
        Header: t("Application End"),
        accessor: "displayEndDate",
        filterable: true,
        sortable: false,
        thWidth: 140,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = cell?.value ? moment.utc(cell?.value).format("YYYY-MM-DD") : "";

          return date ? (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>{date || ""}</span> <br />{" "}
            </div>
          ) : <div className="text-end">-</div>;
        },
      },
      {
        Header: t("Salary + Type"),
        accessor: "salaryAmount",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const status = item?.salaryType;
          let salaryAmount = item?.salaryAmount;

          return <div className="cursor-pointer">
            {
              item?.salaryNegotiable === true ? (
                <>{t("Negotiable")}</>
              ) : (
                <>
                  {`${formatNumberWithCommas(salaryAmount)} ₩/ `}
                  {
                    t(
                      LIST_OPTION_SALARY_TYPE?.find(
                        (item: any) => String(item?.value) === String(status)
                      )?.label || ""
                    )
                  }
                </>
              )
            }
          </div>;
        },
      },
      {
        Header: t("Field of recruitment"),
        accessor: "jobCategoryText",
        thWidth: 170,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const category: any = cell?.value;
          return category ? <div className="cursor-pointer">
            <CopyWrapper contentCopy={category}>
              {`${category}`}
            </CopyWrapper>
          </div> : '-';
        },
      },
      {
        Header: t("Required Gender"),
        accessor: "gender",
        filterable: false,
        sortable: false,
        thWidth: i18n.language === 'en' ? 130 : 100,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const gender = cell?.value;
          return (
            <div style={{ minWidth: 80 }}>
              {t(
                LIST_OPTION_GENDER?.find(
                  (item: any) => String(item?.value) === String(gender)
                )?.label || ""
              )}
            </div>
          );
        },
      },
      {
        Header: t("Employment Type"),
        accessor: "employmentType",
        thWidth: i18n.language === 'en' ? 180 : 120,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status: any = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_EMPLOYMENT_TYPE[status] || "secondary"
                  }`}
              >
                {t(
                  LIST_OPTION_EMPLOYMENT_TYPE?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Work Hours"),
        accessor: "workTimeRange",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          const item = cell?.row?.original;

          return <div className="cursor-pointer">
            {
              item?.workTimeFlexible === true ? (
                <div className="align-items-center gap-1 bg-primary badge rounded-pill">{t("Negotiable")}</div>
              ) : (
                <div className="align-items-center gap-1 bg-badge-workdays badge rounded-pill">{cell?.value || "-"}</div>
              )
            }
          </div>
        },
      },
      {
        Header: t("Work Days"),
        accessor: "workDays",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const workDays = cell?.value;
          const activeDays = workDays ? sortDays(Object.keys(workDays).filter(day => workDays[day] === true)) : [];
          const isNegotiable = workDays?.NEGOTIABLE === true;

          return <div className="cursor-pointer">
            {
              (item?.durationFlexible === true || isNegotiable) ? (
                <div className="align-items-center gap-1 bg-primary badge rounded-pill">{t("Negotiable")}</div>
              ) : activeDays?.length > 0 ? (
                <div className="d-flex flex-wrap align-items-center gap-1">
                  {activeDays?.map((item: any, index: number) => (
                    <div
                      className="d-flex align-items-center gap-1 bg-primary badge rounded-pill"
                      key={index}
                    >
                      {t(item)}
                    </div>
                  ))}
                </div>
              ) : <>-</>
            }
          </div>;
        },
      },
      {
        Header: t("Duration Work"),
        accessor: "durationWork",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap text-center",
        thWidth: 140,
        Cell: (cell: any) => {
          const durationWork = cell?.value;

          return durationWork ? (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_DURATION_WORK[durationWork] || "secondary"
                  }`}
              >
                {t(
                  LIST_OPTION_DURATION_WORK?.find(
                    (item: any) => String(item?.value) === String(durationWork)
                  )?.label || ""
                )}
              </span>
            </div>) : "-"
        },
      },
      {
        Header: t("Store Region"),
        accessor: "Region",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.store?.address;

          return (item?.region1 || item?.region2) ? (
            <div className="d-flex flex-wrap align-items-center gap-1">
              <div
                className="d-flex align-items-center gap-1 bg-primary badge rounded-pill"
              >
                {[item?.region1, item?.region2].filter(Boolean).join(" - ")}
              </div>
            </div>
          ) : "-";
        },
      },
      // {
      //   Header: t("Store Region"),
      //   accessor: "Region",
      //   filterable: true,
      //   sortable: false,
      //   thClass: "whitespace-nowrap",
      //   thWidth: 180,
      //   Cell: (cell: any) => {
      //     const regions: any = cell?.row?.original?.regions;

      //     return (regions?.length > 0) ? (
      //       <div className="d-flex flex-wrap align-items-center gap-1">
      //         {
      //           regions.map((region: any, index: number) => (
      //             <div
      //               key={index}
      //               className="d-flex align-items-center gap-1 bg-primary badge rounded-pill"
      //             >
      //               {[region?.region?.name, region?.subRegion?.name].filter(Boolean).join(" - ")}
      //             </div>
      //           ))
      //         }
      //       </div>
      //     ) : "-";
      //   },
      // },
      {
        Header: t("Total View"),
        accessor: "viewCount",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap text-end",
        thWidth: 100,
        Cell: (cell: any) => {
          return <div className="cursor-pointer text-end">{`${cell?.value || "0"}`}</div>;
        },
      },
      {
        Header: t("Total Application"),
        accessor: "totalApplication",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap text-end",
        thWidth: 150,
        Cell: (cell: any) => {
          return <div className="cursor-pointer text-end">{`${cell?.value || "0"}`}</div>;
        },
      },
      {
        Header: t("Banner Premium"),
        accessor: "sectionItems",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 150,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const bannerPositions = (cell?.value || [])
            .filter((item: any) => (item?.bannerPositionId && item?.bannerImage));
          const bannerPremium = bannerPositions?.[0]?.bannerImage || "" ;

          return  (
            <div className="w-100 text-center " style={{ minWidth: "80px" }}>
              {
                (item?.status === "ACTIVE" && (item?.banner || item?.section?.id === 5)) ? (
                  <div
                    style={{ width: "80px" }}
                    className="m-auto cursor-pointer"
                    onClick={() => {
                      setIsShowBannerPremium(true)
                      setLinkImage({ url: bannerPremium })
                    }}
                  >
                    <img
                      src={bannerPremium ?? noImageJob}
                      width={70}
                      height={70}
                      className=""
                      style={{ objectFit: "contain" }}
                      alt="thumbnail"
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = noImageJob;
                      }}
                    />
                  </div>
                ) : "-"
              }
            </div>
          )
        },
      },
      // {
      //   Header: t("Plan"),
      //   accessor: "planName",
      //   filterable: true,
      //   sortable: false,
      //   thClass: "whitespace-nowrap",
      //   thWidth: 280,
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     const plan = cell?.value;
      //     const currency = item?.banner ? item?.banner?.currency : (item?.section?.currency || "KRW");
      //     const discountRate = plan?.price?.discountRate;

      //     return !plan ? <div className="d-flex gap-2 flex-column" style={{ minWidth: "250px" }}>
      //       <div><small>{t("Plan Name")}: </small>{`${plan?.info?.name || "-"}`}</div>
      //       <div>
      //         <small>{t("Plan Price")}: </small>
      //         <small className="text-decoration-line-through text-secondary padding-right-3">{`${formatNumberWithCommas(plan?.info?.price || "1000000")} `}</small> 
      //         <small className="text-danger" style={{paddingLeft: "5px"}}>
      //           {`${formatNumberWithCommas(plan?.info?.priceFinal || "50000")} `}
      //           {currency === "KRW" ? "₩" : ""}
      //         </small>
      //         <small className="text-secondary" style={{paddingLeft: "5px"}}>{`(${formatNumberWithCommas(discountRate || "10")}%)`}</small>
      //       </div>
            
      //     </div> : '-';
      //   },
      // },
      // {
      //   Header: t("Section"),
      //   accessor: "sectionName",
      //   filterable: true,
      //   sortable: false,
      //   thClass: "whitespace-nowrap",
      //   thWidth: 280,
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     const plan = cell?.value;
      //     const currency = item?.banner ? item?.banner?.currency : (item?.section?.currency || "KRW");
      //     const discountRate = item?.banner ? item?.banner?.discountRate : item?.section?.discountRate;

      //     return !plan ? <div className="d-flex gap-2 flex-column" style={{ minWidth: "250px" }}>
      //       <div><small>{t("Section Name")}: </small>{`${plan?.info?.name || "-"}`}</div>
      //       <div>
      //         <small>{t("Section Price")}: </small>
      //         <small className="text-decoration-line-through text-secondary padding-right-3">{`${formatNumberWithCommas(plan?.info?.price || "1000000")} `}</small> 
      //         <small className="text-danger" style={{paddingLeft: "5px"}}>
      //           {`${formatNumberWithCommas(plan?.info?.priceFinal || "50000")} `}
      //           {currency === "KRW" ? "₩" : ""}
      //         </small>
      //         <small className="text-secondary" style={{paddingLeft: "5px"}}>{`(${formatNumberWithCommas(discountRate || "10")}%)`}</small>
      //       </div>
            
      //     </div> : '-';
      //   },
      // },
      // Delete
      {
        Header: t("Plan"),
        accessor: "plan",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 200,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const plan = cell?.value;

          return plan ? <div className="d-flex gap-2 flex-column" style={{ minWidth: "200px" }}>
            <div>{plan?.info?.name}</div>
            <small>{plan?.info?.description}</small>
            <div className="cursor-pointer d-flex gap-2">
              {plan?.features
                ? plan?.features?.map((feature: any, index: number) => (
                  <span
                    className={`rounded-pill badge bg-primary`}
                    key={index}
                  >
                    {t(
                      PLAN_FEATURE_KEY_OPTION?.find(
                        (item: any) => String(item?.value) === String(feature?.key)
                      )?.label || ""
                    )}
                  </span>
                ))
                : "-"}
            </div>
          </div> : '-';
        },
      },

      {
        Header: t("Plan Price"),
        accessor: "plan.price.price",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            cell?.value ? (
              <div className="text-end cursor-pointer" >
                {`${formatNumberWithCommas(cell?.value)} `}
                {item?.payment?.currency === "KRW" ? "₩" : ""}
              </div>
            ) : <div className="text-end" >-</div>
          );
        },
      },
      {
        Header: `${t("Discount Plan Rate")} (%)`,
        accessor: "plan.price.discountRate",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 180,
        Cell: (cell: any) => {
          const discountRate = cell?.value;
          const priceType = cell?.row?.original?.priceType;

          return (
            <>
              <div className="cursor-pointer text-end" style={{ minWidth: "120px" }}>
                {(discountRate && priceType !== "FREE") ? `${formatNumber(discountRate)}%` : "-"}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Plan Final Price"),
        accessor: "plan.price",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 150,
        Cell: (cell: any) => {
          const item = cell?.row?.original?.plan?.price;
          const priceType = cell?.row?.original?.plan?.priceType;
          const currency = item?.currency === "KRW" ? "₩" : "$";
          const priceFinal = item?.priceFinal;

          return (
            <>
              <div className="cursor-pointer text-end" style={{ minWidth: "120px" }}>
                {(priceFinal && priceType !== "FREE") ? `${formatNumber(priceFinal)} ${currency}` : "-"}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Section Name"),
        accessor: "section.name",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: " whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const dataSection = item?.banner ? item?.banner : item?.section;

          return (
            dataSection ? (
              <div className=" cursor-pointer" >
                {`${(dataSection?.fullName)} `}
              </div>
            ) : <div className="" >-</div>
          );
        },
      },
      {
        Header: t("Section Price"),
        accessor: "section1",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const priceSection = item?.banner ? item?.banner?.price : item?.section?.price;
          const currency = item?.banner ? item?.banner?.currency : item?.section?.currency;

          return (
            priceSection ? (
              <div className="text-end cursor-pointer" >
                {`${formatNumberWithCommas(priceSection)} `}
                {currency === "KRW" ? "₩" : ""}
              </div>
            ) : <div className="text-end" >-</div>
          );
        },
      },
      {
        Header: `${t("Discount Section Rate")} (%)`,
        accessor: "discountRate",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 220,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const discountRate = item?.banner ? item?.banner?.discountRate : item?.section?.discountRate;
          const priceType = cell?.row?.original?.priceType;

          return (
            <>
              <div className="cursor-pointer text-end" style={{ minWidth: "120px" }}>
                {(discountRate && priceType !== "FREE") ? `${formatNumber(discountRate)}%` : "-"}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Section Final Price"),
        accessor: "section.price",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const priceSection = item?.banner ? item?.banner?.price : item?.section?.price;
          const priceFinalSection = item?.banner ? item?.banner?.priceFinal : item?.section?.priceFinal;

          return (
            priceSection ? (
              <div className="text-end cursor-pointer" >
                {`${formatNumberWithCommas(priceFinalSection)} `}
                {item?.payment?.currency === "KRW" ? "₩" : ""}
              </div>
            ) : <div className="text-end" >-</div>
          );
        },
      },
      // Delete
      {
        Header: t("VAT (%)"),
        accessor: "plan.price.vatRate",
        filterable: true,
        sortable: false,
        thWidth: 120,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <div className="text-end cursor-pointer">
              {cell?.value ? `${cell?.value}%` : "0"}
            </div>
          );
        },
      },
      {
        Header: t("Total Amount"),
        accessor: "payment.totalAmount",
        filterable: true,
        sortable: false,
        thWidth: 180,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            cell?.value ? (
              <div className="text-end cursor-pointer">
                {`${formatNumberWithCommas(cell?.value)} `}
                {item?.payment?.currency === "KRW" ? "₩" : ""}
              </div>
            ) : <div className="text-end cursor-pointer">-</div>
          );
        },
      },
      {
        Header: t("Paid at"),
        accessor: "paidAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              {
                cell?.value ? (
                  <span>
                    <span>{arrDate?.[0] || ""}</span> <br />{" "}
                    <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                  </span>
                ) : 
                "-"
              }
            </div>
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "createdAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updatedAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },

      },
      {
        Header: t("Action"),
        thClass: "text-center",
        thWidth: 110,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0"
              style={{ minWidth: "70px" }}
            >
              <TooltipCustom
                title={t("Button Update Job Post")}
                id={`update-us-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e: any) => {
                    e.preventDefault();
                    setIsOpen(true);
                    setItemToEdit(item);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </Link>
              </TooltipCustom>

              <TooltipCustom
                title={t("Delete Job Post")}
                id={`detail-cp-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e: any) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, jobPosts?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };
  // Begin::Delete

  const handleActionDelete = async (id: any) => {
    if (!id) return;

    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await jobPostApi.deleteJobPost(id);
      if (response?.code) {
        setIsConfirmLoading((_prev) => false);
        dispatch(getJobPosts(query));
        setItemToDelete(false);
        toast(
          `${t("The job posting has been deleted.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // End::Delete
  const sortedBenefitsPreferences = (data: any) => {
    if (data?.length < 0) return;

    return data?.sort((a: any, b: any) => {
      if (a.isCustom === b.isCustom) return 0;
      return a.isCustom ? 1 : -1;
    }) || [];
  }
  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [resBenifitCondition, resJobCategories]: any = await Promise.all([
          benifitJobPostApi.benifitActive(),
          jobCategoryApi.getJobCategories(),
        ]);

        if (resBenifitCondition?.data) {
          setDataBenifits(sortedBenefitsPreferences(resBenifitCondition?.data?.benefits))
          setDataConditions(sortedBenefitsPreferences(resBenifitCondition?.data?.preferences))
        }

        if (resJobCategories?.data) {
          const formatJobCategory = resJobCategories?.data?.map((item?: any) => ({
            label: item?.name,
            value: item?.id
          }));
          setDataJobCategory(formatJobCategory || [])
        }

      } catch (error: any) {
        return error;
      }
    };
    handleCallAllOption();
  }, []);

  const onCloseImageClick = () => {
    setLinkImage(null);
  };
  
  const handleChangeRegion = (newValues: any) => {
    if (newValues.includes("ALL")) {
      setSelectedRegionSearch(["ALL"]);
      return;
    }

    const filtered = newValues.filter((val: any) => val !== "ALL");
    setSelectedRegionSearch(filtered);
  };

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [resRegion, resSections, resPlans]: any = await Promise.all([
          regionApi.getRegions(),
          sectionApi.getSections(),
          plansApi.getPlans()
        ]);
        
        if (resRegion?.data) {
          const formatRegions = resRegion?.data?.map((item: any) => {
            const formatSubRegion = item?.subRegions?.map((sub: any) => {
              return {
                value: sub?.id,
                label: sub?.name
              }
            })
            return {
              value: item?.id,
              label: item?.name,
              children: formatSubRegion || []
            }
          })
          setRegions(formatRegions)

          setLstTreeRegion(formatRegions?.map((item: any) => {
            return {
              title: item?.label,
              value: String(item?.value),
              children: item?.children?.map((sub: any) => ({
                title: sub?.label,
                value: `${item?.value}-${sub?.value}`
              }))
            }
          }));
        }

        if (resSections?.data) {
          const formatDataSection = resSections?.data?.map((item: any) => ({
            label: item?.fullName,
            value: item?.id,
            data: item
          }))
          setDataSection(formatDataSection)
        }

        if (resPlans?.data) {
          const formatDataPlan = resPlans?.data?.items?.map((item: any) => {
            return {
              label: item?.info?.name,
              value: item?.id,
              data: item,
          }})
          const formatDataPlanActive = formatDataPlan?.filter((item: any) => (item?.data?.isActive) === true) || [];

          setDataPlan(formatDataPlanActive)
          setDataPlanAll(formatDataPlan)
        }

      } catch (error: any) {
        return error;
      }
    };

    handleCallAllOption();
  }, [])

  useEffect(() => {
    document.title = `${t("Job Post Menu")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Job Post Menu")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={jobPosts?.summary?.total || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Job Post Active")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      jobPosts?.summary?.totalActive || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Draft")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      jobPosts?.summary?.totalDraft || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Payment Pending")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      jobPosts?.summary?.totalPendingPayment || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Payment Cancel")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      jobPosts?.summary?.totalPaymentCancel || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Job Post Schedule")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      jobPosts?.summary?.totalSchedule || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Expired")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      jobPosts?.summary?.totalExpired || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("End")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      (jobPosts?.summary?.totalPaused + jobPosts?.summary?.totalClosed + jobPosts?.summary?.totalRejected) || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                    <div className="col-sm-auto text-end">
                      <button
                        type="button"
                        className="btn btn-success d-md-block"
                        onClick={() => {
                          setIsOpen(true);
                          setItemToEdit(null);
                        }}
                      >
                        <i className="ri-add-fill align-bottom me-1"></i>{" "}
                        {t("Button Create Job Post")}
                      </button>
                    </div>
                  </div>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Job Title")}`}
                          isShow={!!jobTitleSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Job Title")}...`}
                            value={jobTitleSearch}
                            onChange={(e) => setJobTitleSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Email")}
                          isShow={!!emailSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Email")}...`}
                            value={emailSearch}
                            onChange={(e) => setEmailSearch(e.target.value)}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          isShow={!!storeNameSearch}
                          label={`${t("Store Name")}`}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Store Name")}...`}
                            value={storeNameSearch}
                            onChange={(e) => setStoreNameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Business Number")}`}
                          isShow={!!businessNumberSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Business Number")}...`}
                            value={businessNumberSearch}
                            onChange={(e) => setBusinessNumberSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Store Address")}`}
                          isShow={!!storeAddressSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Store Address")}...`}
                            value={storeAddressSearch}
                            onChange={(e) => setStoreAddressSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Salary Type")} isShow={true}>
                          <DropdownOptionNew
                            name="salary"
                            dataList={LIST_OPTION_SALARY_TYPE || []}
                            placeholder={`${t("Salary Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={salaryTypeSearch}
                            onChangeSelect={(e: any) =>
                              setSalaryTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Employment Type")} isShow={true}>
                          <DropdownStatusNew
                            name="employment-type"
                            dataList={LIST_OPTION_EMPLOYMENT_TYPE || []}
                            placeholder={`${t("Employment Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={employmentTypeSearch}
                            onChangeSelect={(e: any) =>
                              setEmploymentTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_EMPLOYMENT_TYPE}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Duration Work")} isShow={true}>
                          <DropdownOptionNew
                            name="duration-work"
                            dataList={LIST_OPTION_DURATION_WORK || []}
                            placeholder={`${t("Duration Work")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={durationWorkSearch}
                            onChangeSelect={(e: any) =>
                              setDurationWorkSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Required Gender")} isShow={true}>
                          <DropdownOptionNew
                            name="required-gender"
                            dataList={LIST_OPTION_GENDER || []}
                            placeholder={`${t("Required Gender")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={genderSearch}
                            onChangeSelect={(e: any) =>
                              setGenderSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      {/* <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={`${t("Province/Metropolitan City")}`} isShow={true}>
                          <DropdownOptionMulti
                            name="region1"
                            dataList={regions}
                            placeholder={`${t("Province/Metropolitan City")}...`}
                            initialValue={region1Search || null}
                            onChangeSelect={(e: any) => {
                              if (e?.length === 0 || e?.value === 'all') {
                                setIsMultiRegion1(false)
                                setRegion1Search({
                                  label: t("All Filter"),
                                  value: "all",
                                })
                                setRegion2Search({
                                  label: t("All Filter"),
                                  value: "all",
                                })
                              } else {
                                handleSelectedRegion1(e);
                                setIsMultiRegion1(checkHasAllOption(e) ? false : true)
                              }
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "all" }}
                            isMulti={isMultiRegion1}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={`${t("City/District")}`} isShow={true} disabled={true}>
                          <DropdownOptionMulti
                            name="region2"
                            dataList={lstRegion2}
                            placeholder={`${t("Select City/District")}...`}
                            initialValue={region2Search || null}
                            onChangeSelect={(e: any) => {
                              if (e?.length === 0 || e?.value === 'all') {
                                setIsMultiRegion2(false)
                                setRegion2Search({
                                  label: t("All Filter"),
                                  value: "all",
                                })
                              } else {
                                handleSelectedRegion2(e);
                                setIsMultiRegion2(checkHasAllOption(e) ? false : true)
                              }
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "all" }}
                            isMulti={isMultiRegion2}
                            isDisabled={(region1Search?.length === 0 || region1Search?.value === 'all') ? true : false}
                          />
                        </LabelWrapper>
                      </Col> */}

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Job Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={LIST_OPTION_STATUS_JOB_POST || []}
                            placeholder={`${t("Job Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={jobStatusSearch}
                            onChangeSelect={(e: any) =>
                              setJobStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_JOB_POST}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Source Creator")} isShow={true}>
                          <DropdownStatusNew
                            name="source-creator"
                            dataList={LIST_OPTION_SOURCE_CREATOR || []}
                            placeholder={`${t("Source Creator")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={sourceCreatorSearch}
                            onChangeSelect={(e: any) =>
                              setSourceCreatorSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_SOURCE_CREATOR}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Source Channel")} isShow={true}>
                          <DropdownStatusNew
                            name="source-channel"
                            dataList={LIST_OPTION_SOURCE_CHANNEL || []}
                            placeholder={`${t("Source Channel")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={sourceChannelSearch}
                            onChangeSelect={(e: any) =>
                              setSourceChannelSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_SOURCE_CHANNEL}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Job Display Status")} isShow={true}>
                          <DropdownStatusNew
                            name="display-status"
                            dataList={STATUS_JOB_POST_DISPLAY_STATUS_OPTION || []}
                            placeholder={`${t("Job Display Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={displayStatusSearch}
                            onChangeSelect={(e: any) =>
                              setDisplayStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_ACTIVE_DISABLE}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Plan")} isShow={true}>
                          <DropdownAsyncPlan
                            name="plan"
                            placeholder={`${t("Plan")}...`}
                            listCheckedOption={planSearch}
                            onChangeSelect={(event: any) =>
                              setPlanSearch(event)
                            }
                            isAllOption={true}
                            hideSelectedOptions={true}
                            isMulti={false}
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Section")} isShow={true}>
                          <DropdownOptionNew
                            name="provider"
                            dataList={dataSection || []}
                            placeholder={`${t("Section")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={sectionSearch}
                            onChangeSelect={(e: any) =>
                              setSectionSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      {/* <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3 region-filter"
                      >
                        <LabelWrapper label={`${t("Region")}`} isShow={true}>
                          <TreeSelect
                            treeLine={true}
                            style={{ width: "100%", height: "38px" }}
                            treeData={[{ title: t("All Filter"), value: "ALL" }, ...lstTreeRegion]}
                            multiple
                            allowClear
                            placeholder={t("Please select region")}
                            className="dropdown-region-rounded"
                            onChange={handleChangeRegion}
                            value={selectedRegionSearch}
                            filterTreeNode={(input, node) =>
                              (node?.title as string)?.includes(input)
                            }
                          />
                        </LabelWrapper>
                      </Col> */}

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={12}
                        lg={12}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-job-post-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={jobPosts?.items?.length ? jobPosts?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={jobPosts?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(jobPosts?.pagination?.total) /
                        Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isJobPostLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal isOpen={isOpen} centered={true} size="xl" scrollable={true}>
          <ModalHeader toggle={onCloseClick}>
            <>
              {!!itemToEdit?.id
                ? t("Button Update Job Post")
                : t("Button Create Job Post")}
            </>{" "}
            <>
              {itemToEdit?.id && (" - " + (itemToEdit?.title || "") || "")}
            </>
          </ModalHeader>
          <ModalBody>
            <div style={{ minHeight: "calc(100dvh - 200px)" }} className="mt-1">
              <JobForm
                id={String(itemToEdit?.id || "")}
                dataBenifits={dataBenifits}
                dataConditions={dataConditions}
                dataRegions={regions}
                dataSection={dataSection}
                dataPlan={dataPlan}
                dataPlanAll={dataPlanAll}
                dataJobCategory={dataJobCategory}
                triggerRefresh={triggerRefresh}
                onClose={onCloseClick}
                setLinkImage={setLinkImage}
              />
            </div>
          </ModalBody>
        </Modal>

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Job Post")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        <ModalPreview
          type={"IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          onClose={() => onCloseImageClick()}
          isBannerPremium={isShowBannerPremium}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default JobPostManagement;
